import { ErrorBoundaryProps } from '@sentry/react/types/errorboundary';
import React, { Suspense, SuspenseProps } from 'react';
import { BodyLoader } from '../Loader';
import { ErrorFallbackPage } from '../ErrorFallback';
import { SentryErrorBoundary } from './SentryErrorBoundary';

interface Props
  extends Omit<ErrorBoundaryProps, 'children' | 'fallback'>,
    Omit<SuspenseProps, 'fallback'> {
  suspenseFallback?: SuspenseProps['fallback'];
  errorFallback?: ErrorBoundaryProps['fallback'];
}

export function SuspenseWithSentryErrorBoundary({
  children,
  suspenseFallback = <BodyLoader />,
  errorFallback = (props) => <ErrorFallbackPage {...props} message={props.error.message} />,
  ...errorProps
}: Props) {
  return (
    <SentryErrorBoundary fallback={errorFallback} {...errorProps}>
      <Suspense fallback={suspenseFallback}>{children}</Suspense>
    </SentryErrorBoundary>
  );
}
